import { defineMessages } from 'react-intl';

const messages = defineMessages({
  deleteTotesConfirmationModalTitle: {
    description: 'Title for tote deletion confirmation modal',
    defaultMessage: 'Delete Totes',
    id: '3IGFPJ',
  },
  deleteTotesConfirmationMessage: {
    description: 'Message for tote deletion confirmation',
    defaultMessage: 'Are you sure you want to delete these totes?',
    id: 'U3PBPH',
  },
  deleteTotesConfirmationFooter: {
    description: 'Footer message for totes deletion confirmation',
    defaultMessage: 'Are you sure you want to continue?',
    id: 'KrGCID',
  },
  deleteTotesModalDeleteButton: {
    description: 'Delete button text in the totes deletion confirmation modal',
    defaultMessage: 'Delete',
    id: '5vjD34',
  },
});

export default messages;
